var _desc, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon Country/germany") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Country/germany",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "germany",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.923,345.043 C52.094,442.527 145.929,512 256,512 C366.071,512 459.906,442.527 496.077,345.043 L256,322.783 L15.923,345.043 Z",
    id: "Path",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,0 C145.929,0 52.094,69.472 15.923,166.957 L256,189.217 L496.077,166.956 C459.906,69.472 366.071,0 256,0 Z",
    id: "Path",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.923,166.957 C5.633,194.69 0,224.686 0,256 C0,287.314 5.633,317.31 15.923,345.043 L496.078,345.043 C506.368,317.31 512,287.314 512,256 C512,224.686 506.368,194.69 496.077,166.957 L15.923,166.957 Z",
    id: "Path",
    fill: "#D80027"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDe);
export default __webpack_public_path__ + "static/media/DE.b39f701d65e9fb9583372ef650452a1d.svg";
export { ForwardRef as ReactComponent };